export default function Product(data) {
    return {
        type: "GET_PRODUCT",
        payload: data
    }
}